// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // baseUrl: 'https://localhost:44359/',
  baseUrl: 'https://center.caret-corp.com/api/',
  firebase: {
    apiKey: 'AIzaSyDJMf903kBu5YZJzxrVvtHAaklYXtPSrRw',
    authDomain: 'caret-center.firebaseapp.com',
    databaseURL: 'https://caret-center.firebaseio.com',
    projectId: 'caret-center',
    storageBucket: 'caret-center.appspot.com',
    messagingSenderId: '681693609704',
    appId: '1:681693609704:web:021485b5cf5f072225935d'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
